import { createContext, useContext, useState } from "react";

export const translations = {
  it: {
    nav: {
      cta: "Richiedi informazioni",
      links: [
        { id: "home", label: "Home" },
        { id: "chi-siamo", label: "Chi siamo" },
        { id: "servizi", label: "Servizi" },
        { id: "gestione", label: "Gestione" },
        { id: "pulizia", label: "Pulizia e cura" },
        { id: "territorio", label: "Il territorio" },
        { id: "privati", label: "Per privati" },
        { id: "contatti", label: "Contatti" }
      ]
    },
    hero: {
      overline: "Golfo del Tigullio · Liguria",
      lines: ["Case impeccabili.", "Ospiti incantati.", "Proprietari sereni."],
      sub: "Élite Service cura la gestione professionale di case e appartamenti per le vacanze nel Golfo del Tigullio: pulizia da hotellerie, check-in e check-out puntuali, manutenzione e accoglienza — da Portofino a Sestri Levante.",
      ctaPrimary: "Richiedi informazioni",
      ctaSecondary: "Scopri i servizi",
      stats: [
        { value: "7/7", label: "assistenza e reperibilità" },
        { value: "100%", label: "standard da hotellerie" }
      ]
    },
    marquee: ["Portofino", "Santa Margherita Ligure", "Rapallo", "Camogli", "Chiavari", "Lavagna", "Sestri Levante"],
    about: {
      overline: "Chi siamo",
      title: "La cura di una casa è un mestiere. Il nostro.",
      text: "Élite Service nasce nel Golfo del Tigullio con un'idea semplice: portare gli standard della grande hotellerie nella gestione degli affitti brevi. Conosciamo ogni borgo, ogni scogliera, ogni stagione di questo territorio — e trattiamo ogni immobile come se fosse il nostro.",
      text2: "Ci occupiamo di gestione case vacanza, affitti brevi e servizi per immobili turistici in tutto il Tigullio — da Portofino a Santa Margherita Ligure, Rapallo, Camogli, Chiavari, Lavagna e Sestri Levante — con la cura discreta di chi questo territorio lo abita ogni giorno.",
      chapters: [
        { num: "01", title: "Professionalità", text: "Un unico interlocutore, processi chiari e report trasparenti. Ogni fase della gestione è documentata, ogni promessa mantenuta." },
        { num: "02", title: "Pulizia impeccabile", text: "Ambienti impeccabili, biancheria curata, profumi discreti. Il primo passo di un ospite in casa deve essere un momento di meraviglia." },
        { num: "03", title: "Cura del dettaglio", text: "Dal kit di benvenuto alla disposizione dei cuscini: sono i dettagli a trasformare un soggiorno in un'esperienza." },
        { num: "04", title: "Radici nel territorio", text: "Viviamo e lavoriamo nel Tigullio: conosciamo ogni via, ogni borgo e ogni stagione tra Portofino e Sestri Levante." }
      ],
      imageCaption: "Dettagli che raccontano la cura"
    },
    services: {
      overline: "Servizi",
      title: "Tutto ciò di cui la tua casa ha bisogno",
      sub: "Un servizio completo di property management nel Tigullio: modulare, su misura, senza pensieri.",
      items: [
        { icon: "Key", title: "Check-in & check-out", text: "Accoglienza puntuale, consegna delle chiavi e verifica accurata dell'immobile a ogni cambio ospite." },
        { icon: "Sparkle", title: "Pulizia professionale", text: "Pulizia di case vacanza con standard da hotellerie: cura, ordine e ambienti profumati." },
        { icon: "Bed", title: "Preparazione e cura", text: "Biancheria da hotel, allestimenti curati e kit cortesia: ogni appartamento pronto a incantare." },
        { icon: "Wrench", title: "Manutenzione e assistenza", text: "Interventi rapidi e assistenza continua, sette giorni su sette, per piccoli e grandi imprevisti." },
        { icon: "UsersThree", title: "Gestione degli ospiti", text: "Comunicazione continua prima, durante e dopo il soggiorno. Recensioni a cinque stelle, naturalmente." },
        { icon: "HandHeart", title: "Accoglienza", text: "Un benvenuto caldo e discreto, con i consigli di chi il territorio lo vive ogni giorno." },
        { icon: "ShieldCheck", title: "Supervisione degli immobili", text: "Controlli periodici e report fotografici: la tua proprietà sempre sotto controllo, anche a distanza." },
        { icon: "Buildings", title: "Gestione completa", text: "Annunci, prenotazioni e tutta la parte contrattuale sono seguiti dall'agenzia immobiliare con cui collaboriamo: noi coordiniamo ogni altro aspetto della gestione." }
      ]
    },
    management: {
      overline: "Per i proprietari",
      title: "Affida la tua casa a chi la tratta come la propria",
      text: "La gestione di case vacanza nel Golfo del Tigullio richiede presenza, competenza e passione. Trasformiamo il tuo immobile in una fonte di reddito serena: ci occupiamo di ospiti, pulizie e manutenzione, e per la parte burocratica ci affidiamo a un'agenzia immobiliare, mentre tu segui tutto attraverso report chiari e puntuali.",
      bullets: [
        { icon: "ChartLineUp", text: "Massimizzazione del reddito con prezzi dinamici stagionali" },
        { icon: "FileText", text: "Report mensili trasparenti su entrate e attività" },
        { icon: "ShieldCheck", text: "Verifica accurata dell'immobile a ogni check-out" }
      ],
      cta: "Valuta il tuo immobile",
      imageCaption: "Villa sul mare, Santa Margherita Ligure"
    },
    cleaning: {
      overline: "Pulizia e cura",
      title: "Lo standard che ci distingue",
      text: "La pulizia degli appartamenti turistici è il cuore del nostro lavoro. Protocolli rigorosi e controlli minuziosi: ogni ambiente deve essere impeccabile, a ogni arrivo, senza eccezioni.",
      standards: [
        { icon: "Sparkle", title: "Pulizie professionali", text: "Ambienti puliti a fondo a ogni cambio ospite, con prodotti e metodi professionali." },
        { icon: "TShirt", title: "Biancheria da hotellerie", text: "Lavata e stirata da lavanderie professionali." },
        { icon: "FlowerLotus", title: "Atmosfera e profumi", text: "Fragranze discrete e dettagli ricercati in ogni stanza." },
        { icon: "SealCheck", title: "Controllo qualità", text: "Doppia verifica prima di ogni arrivo, con report fotografico." }
      ]
    },
    territory: {
      overline: "Il territorio",
      title: "Il Golfo del Tigullio, la nostra casa",
      text: "Da Portofino a Sestri Levante, passando per Santa Margherita Ligure, Rapallo, Camogli e Chiavari: operiamo dove viviamo. Questa conoscenza profonda del territorio si traduce in ospiti più felici e immobili più valorizzati.",
      captions: ["Portofino", "Santa Margherita Ligure", "Camogli", "Sestri Levante"]
    },
    private: {
      overline: "Servizi per privati",
      title: "Anche per la tua casa",
      text: "Oltre alla gestione delle case vacanza, offriamo servizi di pulizia e cura anche per abitazioni private: interventi su misura, con la stessa attenzione ai dettagli.",
      items: [
        { icon: "House", title: "Pulizie domestiche", text: "Pulizie periodiche o occasionali per appartamenti e ville." },
        { icon: "SprayBottle", title: "Lavavetri", text: "Vetri, vetrate e specchi puliti a fondo, senza aloni." },
        { icon: "HandSoap", title: "Pulizie straordinarie", text: "Interventi intensivi per traslochi, rientri e cambi di stagione." },
        { icon: "Plant", title: "Giardinaggio", text: "Cura di giardini, terrazzi e spazi verdi, tutto l'anno." }
      ],
      cta: "Richiedi un preventivo"
    },
    contact: {
      overline: "Contatti",
      title: "Parliamone",
      text: "Offriamo i nostri servizi di gestione — pulizie, accoglienza e assistenza per ogni imprevisto — a chi ha già avviato una casa vacanza o intende avviarla in autonomia e vuole affidarci i servizi: non ci occupiamo della parte burocratica di avviamento. Se è il tuo caso, scrivici: rispondiamo entro 24 ore.",
      addressLabel: "Sede",
      address: "Golfo del Tigullio, Liguria",
      phoneLabel: "Telefono",
      phone: "+39 375 973 0405",
      emailLabel: "Email",
      email: "eliteservice.agenzia@gmail.com",
      hoursLabel: "Orari",
      hours: "Lun – Ven · 9:00 – 18:00 · Sab – Dom · 9:00 – 12:00 (salvo urgenze)",
      whatsappCta: "Scrivici su WhatsApp",
      form: {
        name: "Nome e cognome",
        email: "Email",
        phone: "Telefono (facoltativo)",
        typeLabel: "Chi sei",
        types: ["Proprietario di immobile", "Ospite / viaggiatore", "Altro"],
        message: "Messaggio",
        placeholder: "Raccontaci del tuo immobile o della tua prossima vacanza…",
        submit: "Invia la richiesta",
        sending: "Invio in corso…",
        error: "Qualcosa è andato storto. Riprova tra poco o scrivici direttamente via email."
      },
      success: {
        title: "Richiesta inviata",
        text: "Grazie per averci scritto. Ti ricontatteremo entro 24 ore lavorative.",
        again: "Invia un'altra richiesta"
      }
    },
    footer: {
      tagline: "Gestione professionale di case vacanza nel Golfo del Tigullio. Pulizia impeccabile, cura dei dettagli, affidabilità.",
      navTitle: "Esplora",
      contactTitle: "Contatti",
      keywords: "Gestione case vacanza Golfo del Tigullio · Affitti brevi Liguria · Property management Tigullio · Pulizia case vacanza · Portofino · Santa Margherita Ligure · Rapallo · Chiavari · Sestri Levante",
      vat: "P.IVA 03098110996",
      rights: "Tutti i diritti riservati."
    }
  },
  en: {
    nav: {
      cta: "Request information",
      links: [
        { id: "home", label: "Home" },
        { id: "chi-siamo", label: "About us" },
        { id: "servizi", label: "Services" },
        { id: "gestione", label: "Management" },
        { id: "pulizia", label: "Cleaning & care" },
        { id: "territorio", label: "The territory" },
        { id: "privati", label: "Private homes" },
        { id: "contatti", label: "Contact" }
      ]
    },
    hero: {
      overline: "Gulf of Tigullio · Liguria",
      lines: ["Impeccable homes.", "Delighted guests.", "Carefree owners."],
      sub: "Élite Service provides professional management of holiday homes and apartments in the Gulf of Tigullio: hotel-grade cleaning, punctual check-ins and check-outs, maintenance and a warm welcome — from Portofino to Sestri Levante.",
      ctaPrimary: "Request information",
      ctaSecondary: "Discover our services",
      stats: [
        { value: "7/7", label: "assistance, every day" },
        { value: "100%", label: "hotel-grade standards" }
      ]
    },
    marquee: ["Portofino", "Santa Margherita Ligure", "Rapallo", "Camogli", "Chiavari", "Lavagna", "Sestri Levante"],
    about: {
      overline: "About us",
      title: "Caring for a home is a craft. Ours.",
      text: "Élite Service was born in the Gulf of Tigullio with a simple idea: bringing the standards of great hospitality to short-term rental management. We know every village, every cliff, every season of this coastline — and we treat every property as if it were our own.",
      text2: "We manage holiday homes, short-term rentals and services for tourist properties across the Tigullio — from Portofino to Santa Margherita Ligure, Rapallo, Camogli, Chiavari, Lavagna and Sestri Levante — with the discreet care of people who live this coastline every day.",
      chapters: [
        { num: "01", title: "Professionalism", text: "One point of contact, clear processes and transparent reporting. Every step is documented, every promise kept." },
        { num: "02", title: "Impeccable cleaning", text: "Impeccable rooms, curated linens, discreet fragrances. A guest's first step inside should be a moment of wonder." },
        { num: "03", title: "Eye for detail", text: "From the welcome kit to the arrangement of cushions: details are what turn a stay into an experience." },
        { num: "04", title: "Rooted in the territory", text: "We live and work in the Tigullio: we know every street, every village and every season between Portofino and Sestri Levante." }
      ],
      imageCaption: "Details that tell of care"
    },
    services: {
      overline: "Services",
      title: "Everything your home needs",
      sub: "A complete property management service in the Tigullio: modular, tailored, worry-free.",
      items: [
        { icon: "Key", title: "Check-in & check-out", text: "Punctual welcomes, key handover and a careful property inspection at every guest change." },
        { icon: "Sparkle", title: "Professional cleaning", text: "Holiday-home cleaning to hotel standards: care, order and beautifully scented rooms." },
        { icon: "Bed", title: "Preparation & care", text: "Hotel-grade linens, curated staging and courtesy kits: every apartment ready to enchant." },
        { icon: "Wrench", title: "Maintenance & assistance", text: "Rapid interventions and continuous assistance, seven days a week, for issues big and small." },
        { icon: "UsersThree", title: "Guest management", text: "Continuous communication before, during and after the stay. Five-star reviews, naturally." },
        { icon: "HandHeart", title: "Hospitality", text: "A warm, discreet welcome, with advice from people who live this territory every day." },
        { icon: "ShieldCheck", title: "Property supervision", text: "Periodic inspections and photographic reports: your property always under control, even from afar." },
        { icon: "Buildings", title: "Full management", text: "Listings, bookings and all contractual matters are handled by the real estate agency we partner with; we coordinate every other aspect of the management." }
      ]
    },
    management: {
      overline: "For owners",
      title: "Entrust your home to those who treat it as their own",
      text: "Managing holiday homes in the Gulf of Tigullio takes presence, expertise and passion. We turn your property into a serene source of income: we handle guests, cleaning and maintenance, and for the bureaucratic side we rely on a real estate agency, while you follow everything through clear, punctual reports.",
      bullets: [
        { icon: "ChartLineUp", text: "Income maximised with seasonal dynamic pricing" },
        { icon: "FileText", text: "Transparent monthly reports on earnings and activity" },
        { icon: "ShieldCheck", text: "Careful property inspection at every check-out" }
      ],
      cta: "Value your property",
      imageCaption: "Seaside villa, Santa Margherita Ligure"
    },
    cleaning: {
      overline: "Cleaning & care",
      title: "The standard that sets us apart",
      text: "Cleaning holiday apartments is the heart of our work. Rigorous protocols and meticulous checks: every room must be impeccable, at every arrival, without exception.",
      standards: [
        { icon: "Sparkle", title: "Professional cleaning", text: "Rooms cleaned in depth at every guest change, with professional products and methods." },
        { icon: "TShirt", title: "Hotel-grade linens", text: "Washed and pressed by professional laundries." },
        { icon: "FlowerLotus", title: "Atmosphere & fragrance", text: "Discreet scents and refined details in every room." },
        { icon: "SealCheck", title: "Quality control", text: "Double inspection before every arrival, with a photographic report." }
      ]
    },
    territory: {
      overline: "The territory",
      title: "The Gulf of Tigullio, our home",
      text: "From Portofino to Sestri Levante, through Santa Margherita Ligure, Rapallo, Camogli and Chiavari: we work where we live. This deep knowledge of the territory means happier guests and better-valued properties.",
      captions: ["Portofino", "Santa Margherita Ligure", "Camogli", "Sestri Levante"]
    },
    private: {
      overline: "Services for private homes",
      title: "For your home too",
      text: "Beyond holiday-home management, we also offer cleaning and care services for private residences: tailored interventions, with the same attention to detail.",
      items: [
        { icon: "House", title: "Home cleaning", text: "Regular or one-off cleaning for apartments and villas." },
        { icon: "SprayBottle", title: "Window cleaning", text: "Windows, glass walls and mirrors cleaned in depth, streak-free." },
        { icon: "HandSoap", title: "Deep cleaning", text: "Intensive interventions for moves, homecomings and seasonal changes." },
        { icon: "Plant", title: "Gardening", text: "Care of gardens, terraces and green spaces, all year round." }
      ],
      cta: "Request a quote"
    },
    contact: {
      title: "Let's talk",
      text: "We offer our management services — cleaning, hospitality and assistance for any unforeseen issue — to those who already run a holiday home or plan to start one on their own and want to hire us for the services: we do not handle the bureaucratic start-up side. If this is your case, write to us: we reply within 24 hours.",
      addressLabel: "Office",
      address: "Golfo del Tigullio, Liguria",
      phoneLabel: "Phone",
      phone: "+39 375 973 0405",
      emailLabel: "Email",
      email: "eliteservice.agenzia@gmail.com",
      hoursLabel: "Hours",
      hours: "Mon – Fri · 9:00 am – 6:00 pm · Sat – Sun · 9:00 am – 12:00 pm (emergencies only)",
      whatsappCta: "Message us on WhatsApp",
      form: {
        name: "Full name",
        email: "Email",
        phone: "Phone (optional)",
        typeLabel: "You are",
        types: ["Property owner", "Guest / traveller", "Other"],
        message: "Message",
        placeholder: "Tell us about your property or your next holiday…",
        submit: "Send request",
        sending: "Sending…",
        error: "Something went wrong. Please try again shortly or email us directly."
      },
      success: {
        title: "Request sent",
        text: "Thank you for writing to us. We will get back to you within 24 working hours.",
        again: "Send another request"
      }
    },
    footer: {
      tagline: "Professional holiday-home management in the Gulf of Tigullio. Impeccable cleaning, attention to detail, reliability.",
      navTitle: "Explore",
      contactTitle: "Contact",
      keywords: "Holiday home management Gulf of Tigullio · Short-term rentals Liguria · Property management Tigullio · Holiday home cleaning · Portofino · Santa Margherita Ligure · Rapallo · Chiavari · Sestri Levante",
      vat: "P.IVA 03098110996",
      rights: "All rights reserved."
    }
  }
};

const LangContext = createContext(null);

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState("it");
  const t = translations[lang];
  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
};

export const useLang = () => useContext(LangContext);
